
import { createSlice } from '@reduxjs/toolkit';
import pageMeta from '../../models/pagemeta.model';
import faq from '../../models/qna.model';

interface faqState{
  faqs:Array<faq>|undefined,
  loading:boolean,
  errors:any,
  meta:pageMeta|undefined
}



const initialState:faqState = {
  faqs:undefined,
  loading:false,
  errors:false,
  meta:undefined,
}

const FaqSlice = createSlice({
  name:'faq',
  initialState:initialState,
  reducers:{
    fetchFaqRequest(state){
      state.loading = true;
    },

    fetchFaqSuccess(state,actions){
      state.loading = false;
      state.faqs = actions.payload.faqs;
      state.meta = actions.payload.meta;
    },

    fetchFaqFail(state,actions){
      state.loading = false;
      state.errors = actions.payload;
    },
  }
});

export const {
  fetchFaqFail,
  fetchFaqRequest,
  fetchFaqSuccess
} = FaqSlice.actions;

export default FaqSlice.reducer;